import { memo, FunctionComponent, useMemo } from 'react';
import { Item as ItemType, Odd as OddType } from '~types';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import Currency from '~components/Currency';
import { Price } from '~ui/index';
import { GetName, SteamItemImage } from '~components/item';
import { useConfig } from '~components/hooks';

import playAudio from '~frontend/utils/playAudio';

interface ItemProps {
  getItem: ItemType;
  getOdd: OddType;
}

const Item: FunctionComponent<ItemProps> = ({ getItem, getOdd }) => {
  const getChance =
    getOdd?.itemsPercents[_.replace(getItem.name, /.*(StatTrak™)./gm, '')];
    const getConfig = useConfig();

  const rars = useMemo(
    () =>
      _.map(
        _.orderBy(
          _.filter(getOdd?.itemsOdds, ['name', getItem.name]),
          ['price'],
          ['desc'],
        ),
        item => (
          <div className="in-case-item-rar-table-row" key={item.id}>
            <span>{item.quality}</span>
            <span>
              {getConfig.isEU ? (
                <>
                  <Currency />
                  <Price sum={item.price} />
                </>
              ) : (
                <>
                  <Price sum={item.price} />
                  <Currency />
                </>
              )}
            </span>
            <span>{item.chance}%</span>
          </div>
        ),
      ),
    [getItem.name, getOdd?.itemsOdds],
  );

  return (
    <div
      className="in-case-item status-1"
      data-rar={getItem.color}
      onMouseEnter={playAudio}
      data-audio="5.wav"
      data-volume="0.4"
    >
      <div className="in-case-item-stats">
        {getChance && <div className="drop-chance">{getChance}%</div>}
      </div>
      <div className="in-case-item-wrap">
        <div className="in-case-item-rar-table-wrap">
          <div className="in-case-item-rar-table">
            <div className="in-case-item-rar-table-head">
              <span>Quality</span>
              <span>Price</span>
              <span>Odds</span>
            </div>
            {rars}
          </div>
        </div>
        <div className="img">
          <div className="in-case-item-bg" />
          <div className="in-case-btns" style={{ display: 'none' }}>
            <Link className="btn-search" to={`/search/${getItem?.id}`}>
              <div className="icon material-icons">search</div>
            </Link>
          </div>
          <div className="other-labels-item">
            {getItem.isStatTrak && (
              <div className="stattrack">
                <span className="fas fa-star" /> StatTrak™
              </div>
            )}
          </div>

          <SteamItemImage
            src={`${getItem.getImage}/350x262`}
            alt={getItem.getName}
          />
          <div className="honey"></div>
        </div>
        <div className="in-case-info">
          <div className="in-case-item-name">
            <GetName getItem={getItem} type={0} />
          </div>
          <div className="in-case-item-desc">
            <GetName getItem={getItem} type={1} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Item);
